import React from "react";

const AboutSlideOne = () => {
  return (
    <div className="swiper-slide-section">
      <h2 className="highlighted">Verwendungsmöglichkeiten</h2>
      <div className="subsection">
        <h3>Grundidee</h3>
        <p>
          Auf "loc.ur.de" können Sie alle relevanten Informationen über einen
          Raum erfragen. Dazu zählen neben <u>allgemeinen Rauminformationen</u>{" "}
          auch <u>Raumbelegungspläne</u>, <u>Raumausstattung</u>,{" "}
          <u>individuelle Störungsmeldungen</u>, und vieles mehr!
        </p>
      </div>
      <div className="subsection">
        <h3>Manuelle Raumsuche</h3>
        <p>
          Mithilfe der <u>manuellen Raumsuche</u> können Sie einfach jederzeit
          einen beliebigen Raum suchen und alle benötigten Informationen über
          diesen erfahren.
        </p>
      </div>
      <div className="subsection">
        <h3>QR-Scan vor Ort</h3>
        <p>
          Falls Sie vor einen Raum stehen, der Sie interessiert, können sie über
          die <u>QR-Suche</u> einfach alle benötigen Informationen über den Raum
          erfahren.
        </p>
      </div>
      <div className="subsection">
        <h3>Allgemeine Störungsmeldungen</h3>
        <p>
          Von Zeit zu Zeit existieren <u>Störungsmeldungen</u> zu Systemen, die
          ebenfalls über diese Anwendung einsehbar sind. Zudem können Sie
          jederzeit selbst <u>Störungsmeldungen</u> melden.
        </p>
      </div>
      <div className="subsection">
        <h3>Freie Räume</h3>
        <p>
          <strong>Diese Funktion ist leider noch nicht verfügbar.</strong>
        </p>
        <p>
          In Zukunft soll es möglich sein, <u>freie Räume</u> in Ihrer Nähe über
          diese Anwendung zu finden.
        </p>
      </div>
    </div>
  );
};

export default AboutSlideOne;
